import RTMTableContainer from '../container/RTMTableContainer';
import RTMSelectedAndTableSkeleton from '../skeleton/RTMSelectedAndTableSkeleton';
import Style from '../styles/RTMView.module.scss';
import { RTMViewProps } from '../types/RTMTypes';
import RTMFilterView from './RTMFilterView';
import _ from 'lodash';

const RTMView = (props: RTMViewProps) => {
  return (
    <div className={Style.RTMView}>
      <div className='RTMView-container'>
        <div className='filter-container'>
          <RTMFilterView
            tableFilter={props.tableFilter}
            handleFilter={props.handleFilter}
            refreshTable={props.refreshTable}
          />
        </div>
        <div className='body-container'>
          {props.loadingTable ? (
            <RTMSelectedAndTableSkeleton />
          ) : (
            <RTMTableContainer
              productsInTable={[...props.productsInTable]}
              selectedProducts={props.selectedProducts}
              siteProducts={props.siteProducts}
              siteId={props.siteId}
              tableFilter={props.tableFilter}
              getData={props.getData}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default RTMView;
